import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import classNames from 'classnames';
import Overlay from 'bootstrap/Overlay';
import Popover from 'bootstrap/Popover';
import RoleHelper from 'shared/lib/role';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import PresetDurationPicker from 'shared/components/pickers/presetDurationPicker.jsx';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import TimeInfoIcon from './timeInfoIcon.jsx';

/**
 * Popover-wrapped preset duration picker
 */
const PresetDurationPickerPopover = React.createClass({
  mixins: [Reflux.connect(PopoverStore, 'popoverVisibility'), PureRenderMixin],

  displayName: 'DurationPickerPopover',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  propTypes: {
    className: React.PropTypes.string,
    value: React.PropTypes.number.isRequired, // Used to initialize state
    onChange: React.PropTypes.func.isRequired,
    hoverable: React.PropTypes.bool,
    showResetButton: React.PropTypes.bool,
    buttonsComponents: React.PropTypes.element,
  },

  getDefaultProps() {
    return {
      className: 'input-duration-wrapper',
      value: 0,
    };
  },

  getInitialState() {
    return {
      value: null,
      valueChanged: false,
    };
  },

  render() {
    return (
      <div className={this.props.className}>
        {this._getDisplayNode()}
        {this._getDurationPickerNode()}
      </div>
    );
  },

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value && !this.state.valueChanged) {
      this.setState({ value: nextProps.value });
    }
  },

  _getDisplayNode() {
    return <div ref="target">{this.props.displayNode}</div>;
  },

  _getValue() {
    let val = this.state.value;

    if (val === null) val = this.props.value;

    return val;
  },

  _hasAdmin() {
    const params = this.context.router.state.params;
    const { teamId, eventId } = params;

    return RoleHelper.hasEventAdminRole(this.props.user, teamId, eventId);
  },

  _getPopoverId() {
    return EditableCellTypes.ItemPresetDuration + this.props.rowIndex;
  },

  _getDurationPickerNode() {
    const {
      simple,
      // pickerType,
    } = this.props;

    let value = this._getValue();

    // const pickerTypeClass = pickerType + 'preset-cell';

    const popoverClassNames = classNames(
      'duration-picker-popover',
      'preset-cell',
      { 'simple-cell': simple },
    );

    return (
      <Overlay
        rootClose
        container={document.body}
        show={this.state.popoverVisibility.get(this._getPopoverId())}
        placement={'left'}
        target={() => ReactDOM.findDOMNode(this.refs.target)}
        onHide={() => this._handleClose()}
        animation={false}
      >
        <Popover
          id={'popover-duration-picker-' + this._getPopoverId()}
          className={popoverClassNames}
        >
          <div
            onKeyDown={(e) => {
              // keyCode 27 - esc
              if (e.keyCode === 27) {
                this._handleClose(true);
              }
            }}
          >
            <CueesheetPresetDurationPicker
              {...this.props}
              value={value}
              popoverId={this._getPopoverId()}
              onResetClicked={this._handleReset}
              onClose={this._handleClose}
              onChange={this._handleChange}
              onTab={this._handleClose}
              valueChanged={this.state.valueChanged}
            />
          </div>
        </Popover>
      </Overlay>
    );
  },

  _handleChange(value) {
    this.setState({ value, valueChanged: true });
  },

  _handleReset() {
    const { rowIndex } = this.props;

    this.setState({ value: 0, valueChanged: true });

    CuesheetCellActions.saveItemTimeFields(rowIndex, {
      presetDurationInSeconds: 0,
      presetDurationInReverse: false,
    });

    setTimeout(this._handleClose, 200);
  },

  _handleClose(escaped) {
    PopoverActions.hide(this._getPopoverId());

    /**
     * @param escape Used to fix issue where escape persists value of changed field
     * when re-opening picker
     */
    if (escaped) {
      const { value } = this.props;

      this.setState({ value });
    } else {
      const { onChange } = this.props;

      const value = this._getValue();

      this.setState({ valueChanged: false }, () => onChange(value));
    }
  },
});

/**
 * The actual duration picker
 *
 */
const CueesheetPresetDurationPicker = React.createClass({
  displayName: 'CueesheetPresetDurationPicker',

  propTypes: {
    value: React.PropTypes.number.isRequired,
    onClose: React.PropTypes.func,
    showResetButton: React.PropTypes.bool,
    onResetClicked: React.PropTypes.func,
    buttonsComponent: React.PropTypes.element,
    hasShowcaller: React.PropTypes.bool,
    displayType: React.PropTypes.string,
    popoverId: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      pickerType: 'duration',
    };
  },

  getInitialState() {
    return {
      originalValue: this.props.value,
    };
  },

  render() {
    const {
      value,
      onChange,
      onClose,
      onTab,
      displayType,
      durationText,
    } = this.props;

    // const positiveValue = value > 0 ? value : 0;

    const originalValueText = (
      <span className="original-duration-value">Was: {durationText}</span>
    );

    const cueClockControlsNode = (
      <div className="picker-body text-center">
        <PresetDurationPicker
          {...{ displayType, value, onChange, onClose, onTab }}
        />
        <span>
          {this._getTogglePresetClockNode()}
          {this._getGoalFlagControlsNode()}
          {this._getResetButtonNode()}
        </span>
        <br />
        {originalValueText} <TimeInfoIcon />
      </div>
    );

    return <div className={'duration-picker'}>{cueClockControlsNode}</div>;
  },

  /**
   * Consider refactoring/consolidating with the flag node getter from startTimePicker...it's mostly the same code
   */
  _getGoalFlagControlsNode() {
    // const key = 'presetDurationInReverse';
    const { rowIndex, presetDurationInReverse, value } = this.props;

    const save = (newVal) => {
      const changes = Object.assign(
        { presetDurationInReverse: newVal },
        { presetDurationInSeconds: value },
      );
      CuesheetCellActions.saveItemTimeFields(rowIndex, changes);
    };

    return (
      <span>
        <Icon
          name="flag-arrow-up"
          className={classNames({ active: presetDurationInReverse })}
          ours
          onClick={() => save(true)}
        />
        <Icon
          name="flag-arrow-down"
          className={classNames({ active: !presetDurationInReverse })}
          ours
          onClick={() => save(false)}
        />
      </span>
    );
  },

  _getTogglePresetClockNode() {
    const { displayPresetClock } = this.props;

    return (
      <span className="duration-picker-suppress-toggle">
        <Icon
          name={displayPresetClock ? 'eye' : 'eye-slash'}
          onClick={() => this._toggleDisplayPresetClock()}
        />
      </span>
    );
  },

  _toggleDisplayPresetClock() {
    const { displayPresetClock, popoverId } = this.props;

    const currentValue = displayPresetClock;

    if (currentValue === true) PopoverActions.hide(popoverId);

    CuesheetCellActions.saveItemTimeField(
      this.props.rowIndex,
      'displayPresetClock',
      !currentValue,
    );
  },

  _getResetButtonNode() {
    if (!this.props.showResetButton) return null;

    return (
      <span className="duration-picker-reset-button">
        <Icon onClick={() => this.props.onResetClicked()} name="undo" />
      </span>
    );
  },
});

export default PresetDurationPickerPopover;
